export const language = {
  en: {
    'Log in': 'Log in',
    'Tel Account Login': 'Tel Account Login',
    'Email Account Login': 'Email Account Login',
    'Account': 'Account',
    'Password': 'Password',
    'Forget Password': 'Forget Password',
    'Create an Account': 'Create an Account',
    'Tel Account Sign Up': 'Tel Account Sign Up',
    'Tel Account': 'Tel Account',
    'Email Account Sign Up': 'Email Account Sign Up',
    'Email Account': 'Email Account',
    'Tel': 'Tel',
    '11Tel': '11 digit phone number',
    '6-16 characters, must include letter, digit, and special character': '6-16 characters, must include letter, digit, and special character',
    'Invalid character: ': 'Invalid character: ',
    'Please Enter At Least 6 Characters': 'Please Enter At Least 6 Characters',
    'Confirm Password': 'Confirm Password',
    'Verification Code': 'Verification Code',
    'Enter phone number': 'Enter phone number',
    'Enter email': 'Enter email',
    'Name': 'Name',
    'Company Name': 'Company Name',
    'Unified Tax ID': 'Unified Tax ID',
    'Company Country': 'Company Country',
    'Account or password is wrong, please confirm ': 'Account or password is wrong, please confirm ',
    'This company already exists, please create a new company': 'This company already exists, please create a new company',
    'The verification code has been sent and is valid within 10 minutes': 'The verification code has been sent and is valid within 10 minutes',
    'The account already exists, please log in directly': 'The account already exists, please log in directly',
    'Your account： xxxxxx created successfully': 'Your account： xxxxxx created successfully',
    'Your account：': 'Your account：',
    'created successfully': 'created successfully',
    'Enter Platform': 'Enter Platform',
    'Strength：Safe': 'Strength：Safe',
    'Strength：Too Short': 'Strength：Too Short',
    'Strength：Too Weak': 'Strength：Too Weak',

    'The verification code is incorrect. Please confirm the code.': 'The verification code is incorrect. Please confirm the code.',
    'The verification code is invalid. Please re-send the code.': 'The verification code is invalid. Please re-send the code.',
    'Re-send the code': 'Re-send the code',
    'Get verification code': 'Get verification code',
    'Already have an account': 'Already have an account',
    'Create': 'Create',
    'The account already exists': 'The account already exists',
    'Reset Password': 'Reset Password',
    'The reset password has been sent to your account :xxxxxx': 'The reset password has been sent to your account :xxxxxx',
    'Dear user, here is your verification code:': 'Dear user, here is your verification code:',
    'This is an automatic email. Please kindly ignore or delete the email if it was not you.': 'This is an automatic email. Please kindly ignore or delete the email if it was not you.',
    'New Password': 'New Password',
    'Incorrect phone number format': 'Incorrect phone number format',
    'Incorrect email format': 'Incorrect email format',
    'The two passwords do not match': 'The two passwords do not match',
    'Up to 15 characters': 'Up to 15 characters',
    'Up to 50 digits': 'Up to 50 digits',
    'Please enter the company name (on the business license)': 'Please enter the company name (on the business license)',
    'Digits': 'Digits',
  },
  zh: {
    'Log in': '登录',
    'Tel Account Login': '手机号登录',
    'Email Account Login': '邮箱登录',
    'Account': '账户',
    'Password': '密码',
    'Forget Password': '忘记密码',
    'Create an Account': '注册账户',
    'Tel Account Sign Up': '手机号注册',
    'Tel Account': '手机号重置',
    'Email Account Sign Up': '邮箱注册',
    'Email Account': '邮箱重置',
    'Tel': '手机号',
    '11Tel': '11位手机号',
    '6-16 characters, must include letter, digit, and special character': '6-16位，必须包含字母、数字和特殊字符',
    'Invalid character: ': '无效字符：',
    'Please Enter At Least 6 Characters': '最少6个字符',
    'Confirm Password': '确认密码',
    'Verification Code': '验证码',
    'Enter phone number': '请输入手机号',
    'Enter email': '请输入邮箱',
    'Name': '姓名',
    'Company Name': '公司名称',
    'Unified Tax ID': '统一社会信用代码',
    'Company Country': '国家',
    'Account or password is wrong, please confirm ': '账号或密码错误，请确认后再登录',
    'This company already exists, please create a new company': '该公司已存在，请勿重复创建',
    'The verification code has been sent and is valid within 10 minutes': '验证码已发送，10分钟内有效',
    'The account already exists, please log in directly': '您好，该手机号已注册，请直接登录',
    'Your account： xxxxxx created successfully': '你的账户：xxxxxxxxx注册成功',
    'Your account：': '你的账户：',
    'created successfully': '注册成功',
    'Enter Platform': '进入平台',
    'Strength：Safe': '强度：安全',
    'Strength：Too Short': '强度：太短',
    'Strength：Too Weak': '强度：太弱',

    'The verification code is incorrect. Please confirm the code.': '该验证码错误，请确认后填写',
    'The verification code is invalid. Please re-send the code.': '该验证码已失效，请重新发送',
    'Re-send the code': '后重新发送',
    'Get verification code': '获取验证码',
    'Already have an account': '使用已有帐户登录',
    'Create': '注册',
    'The account already exists': '该账号已存在',
    'Reset Password': '重置密码',
    'The reset password has been sent to your account :xxxxxx': '你的帐户：xxxxxxxxxxxxxx 重置密码已发送，请查收',
    'Dear user, here is your verification code:': '尊敬的用户，您本次操作的数字验证码为',
    'This is an automatic email. Please kindly ignore or delete the email if it was not you.': '此信息由系统生成。如果您并未提交此申请，请忽略或删除此邮件',
    'New Password': '新密码',
    'Incorrect phone number format': '手机号格式不正确',
    'Incorrect email format': '邮箱格式不正确',
    'The two passwords do not match': '两次密码不一致',
    'Up to 15 characters': '最多15个字符',
    'Up to 50 digits': '最多50位',
    'Please enter the company name (on the business license)': '请输入公司名称（营业执照上公司名称）',
    'Digits': '位'
  }
};